// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RundschauUpdateQueryVariables = Exact<{ [key: string]: never }>;

export type RundschauUpdateQuery = {
	rundschau: {
		__typename: 'MangoSeries';
		rowId: string | null;
		episodes: {
			__typename: 'MangoProgrammeConnection';
			nodes: Array<{
				__typename: 'MangoProgramme';
				modifiedAt: string | null;
				broadcasts: {
					__typename: 'MangoBroadcastEventConnection';
					nodes: Array<{
						__typename: 'MangoBroadcastEvent';
						start: string | null;
						end: string | null;
						broadcastedOn: {
							__typename: 'MangoLivestreamConnection';
							nodes: Array<{
								__typename: 'MangoLivestream';
								streamingUrls: {
									__typename: 'MangoLivestreamResourceConnection';
									nodes: Array<{ __typename: 'MangoLivestreamResource'; publicLocation: string | null } | null> | null;
								} | null;
							} | null> | null;
						} | null;
					} | null> | null;
				} | null;
				initialScreening: {
					__typename: 'MangoBroadcastEvent';
					start: string | null;
					end: string | null;
					publishedBy:
						| { __typename: 'MangoBroadcastService'; name: string | null }
						| { __typename: 'MangoPublicationService'; name: string | null }
						| null;
				} | null;
				defaultTeaserImage: { __typename: 'MangoImage'; copyright: string | null; title: string | null; url: string | null } | null;
				videoFiles: {
					__typename: 'MangoVideoFileConnection';
					nodes: Array<{ __typename: 'MangoVideoFile'; publicLocation: string | null } | null> | null;
				} | null;
			} | null> | null;
		} | null;
	} | null;
};

export const RundschauUpdateDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'RundschauUpdate' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rundschau' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'episodes' },
									arguments: [
										{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '2' } },
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'orderBy' },
											value: { kind: 'EnumValue', value: 'BROADCASTS_START_DESC' },
										},
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: {
												kind: 'ObjectValue',
												fields: [
													{
														kind: 'ObjectField',
														name: { kind: 'Name', value: 'broadcasts' },
														value: {
															kind: 'ObjectValue',
															fields: [
																{
																	kind: 'ObjectField',
																	name: { kind: 'Name', value: 'start' },
																	value: {
																		kind: 'ObjectValue',
																		fields: [
																			{
																				kind: 'ObjectField',
																				name: { kind: 'Name', value: 'lt' },
																				value: { kind: 'StringValue', value: 'now(PT2H)', block: false },
																			},
																			{
																				kind: 'ObjectField',
																				name: { kind: 'Name', value: 'gt' },
																				value: { kind: 'StringValue', value: 'now(-P2D)', block: false },
																			},
																		],
																	},
																},
															],
														},
													},
												],
											},
										},
									],
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'nodes' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'broadcasts' },
															arguments: [
																{ kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'IntValue', value: '1' } },
															],
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'nodes' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{ kind: 'Field', name: { kind: 'Name', value: 'start' } },
																				{ kind: 'Field', name: { kind: 'Name', value: 'end' } },
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'broadcastedOn' },
																					arguments: [
																						{
																							kind: 'Argument',
																							name: { kind: 'Name', value: 'first' },
																							value: { kind: 'IntValue', value: '1' },
																						},
																					],
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'nodes' },
																								selectionSet: {
																									kind: 'SelectionSet',
																									selections: [
																										{
																											kind: 'Field',
																											name: { kind: 'Name', value: 'streamingUrls' },
																											arguments: [
																												{
																													kind: 'Argument',
																													name: { kind: 'Name', value: 'first' },
																													value: { kind: 'IntValue', value: '1' },
																												},
																											],
																											selectionSet: {
																												kind: 'SelectionSet',
																												selections: [
																													{
																														kind: 'Field',
																														name: { kind: 'Name', value: 'nodes' },
																														selectionSet: {
																															kind: 'SelectionSet',
																															selections: [
																																{ kind: 'Field', name: { kind: 'Name', value: 'publicLocation' } },
																															],
																														},
																													},
																												],
																											},
																										},
																									],
																								},
																							},
																						],
																					},
																				},
																			],
																		},
																	},
																],
															},
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'initialScreening' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'start' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'end' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'publishedBy' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
																		},
																	},
																],
															},
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'defaultTeaserImage' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
																],
															},
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'videoFiles' },
															arguments: [
																{
																	kind: 'Argument',
																	name: { kind: 'Name', value: 'filter' },
																	value: {
																		kind: 'ObjectValue',
																		fields: [
																			{
																				kind: 'ObjectField',
																				name: { kind: 'Name', value: 'videoProfile' },
																				value: {
																					kind: 'ObjectValue',
																					fields: [
																						{
																							kind: 'ObjectField',
																							name: { kind: 'Name', value: 'id' },
																							value: {
																								kind: 'ObjectValue',
																								fields: [
																									{
																										kind: 'ObjectField',
																										name: { kind: 'Name', value: 'eq' },
																										value: {
																											kind: 'StringValue',
																											value: 'av:http://ard.de/ontologies/audioVideo#VideoProfile_HLS',
																											block: false,
																										},
																									},
																								],
																							},
																						},
																					],
																				},
																			},
																		],
																	},
																},
															],
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'nodes' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [{ kind: 'Field', name: { kind: 'Name', value: 'publicLocation' } }],
																		},
																	},
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<RundschauUpdateQuery, RundschauUpdateQueryVariables>;
